import { currencyRound } from '@gelato-api-ui/core/currency/currency-round';
import { SubscriptionDiscount } from '../types/subscription-discounts';
import { getShippingDiscountValue } from './get-shipping-discount-value';

export function calculateShippingCost(
  productCost = 0,
  shippingCost = 0,
  subscriptionDiscount: SubscriptionDiscount,
  selectedCurrency: string,
): number {
  return currencyRound(
    shippingCost - shippingCost * getShippingDiscountValue(productCost, subscriptionDiscount),
    selectedCurrency,
  );
}
